<script>
    import { toRaw } from 'vue';
    import difference from 'lodash/difference';
    import SingleSelector from "../SingleSelector.vue";
    import { findSolutions } from '../../api/solutions';
    import bus from '../../utils/eventBus';

    export default {
        components: {
            "single-selector": SingleSelector
        },
        props: {
            pageLang: { type: String, default: '' },
            blockId: { type: [String, Number], default: '' },
            blockTitle: { type: String, default: '' },
            rawOptions: { type: Array, default: () => [] },
            rawSolutions: { type: Array, default: () => [] },
            rawCategories: { type: Array, default: () => [] }
        },
        data() {
            return {
                bus: bus,
                showAnimation: true,
                selectedOption: null,
                openDialog: '',
                isLoading: false,
                options: this.rawOptions,
                categories: this.rawCategories,
                solutions: this.rawSolutions
            };
        },
        watch: {
            selectedOption: function () {
                this.showAnimation = false;
                setTimeout(() => {
                    this.showAnimation = true;
                }, 1);
            },
        },
        created() {
            

            if (this.bus && typeof this.bus.$on === 'function') {
                this.bus.$on('dropdownChange', (selected, dropdownId, oldVal) => {
                    // Support legacy object shape ({ reset, item, index }) or new primitive { id, name }
                        if (selected == null) return;
                        if (selected.reset) {
                            this.resetOptions();
                            if (this.$children && this.$children[0]) {
                                this.$children[0].selectedItem = { 'name': this.$children[0].defaultLabel, 'value': 0 };
                            }
                            return;
                        }

                        let payloadItem = null;
                        if (typeof selected === 'object' && (selected.item || selected.index || selected.reset !== undefined)) {
                            // legacy bus emit
                            payloadItem = normalizeDropdown(selected.item);
                        } else {
                            // cover both primitive object ({id,name}) and other shapes
                            payloadItem = normalizeDropdown(selected);
                        }

                        if (payloadItem) {
                            this.optionsChange(payloadItem, selected && selected.index !== undefined ? selected.index : null);
                            if (this.$children && this.$children[0]) {
                                this.$children[0].selectedItem = { 'name': payloadItem.name, 'value': payloadItem.value };
                            }
                        }
                });
            }

            window.addEventListener('click', (e) => {
                if (this.bus && typeof this.bus.$emit === 'function') {
                    this.bus.$emit('hideOtherDropdowns', e.target);
                }
            });
        },
        mounted() {
            if (dataLayer) {
                dataLayer.push({
                    "event": "solution_selector_loaded",
                    "name": this.blockTitle
                });
            }
            const query = this.currentQuery || {};
            if (query.challenge) {
                const initialQuery = parseInt(query.challenge);
                if (Number.isInteger(initialQuery)) {
                    if (this.findInOptions(initialQuery)) {
                        this.selectedOption = initialQuery;
                        this.search({
                            language: this.pageLang,
                            blockId: this.blockId,
                            challenge: this.selectedOption
                        });
                    }
                }
            }
        },
        computed: {
            currentRoute() {
                return (this.$router && this.$router.currentRoute) || {};
            },
            currentQuery() {
                if (this.currentRoute.query) {
                    return this.currentRoute.query;
                }
                const params = new URLSearchParams(window.location.search);
                const q = {};
                params.forEach((v, k) => { q[k] = v; });
                return q;
            },
            isAnyOptionSelected() {
                return this.selectedOption;
            },
            filteredSolutions() {
                if (this.isAnyOptionSelected) {
                    return toRaw(this.solutions).filter(s => s.customerChallenges.some(ch => this.selectedOption === ch));
                } else {
                    return toRaw(this.solutions).filter(s => !s.hideFromMainGrid);
                }
            },
            filteredOutSolutions() {
                return difference(toRaw(this.solutions), this.filteredSolutions).filter(s => !s.hideFromMainGrid);
            }
        },
        methods: {
            search(params) {
                this.isLoading = true;
                findSolutions(params)
                    .then(response => {
                        this.isLoading = false;
                        this.categories = response;
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
            },
            setOpenDialog(category, id) {
                this.openDialog = id + '-' + category;
                setTimeout(function () {
                    $(".activePopup")[0].focus();
                }, 100);
            },
            closeDialog() {
                this.openDialog = '';
            },
            optionsChange: function (option, index) {
                this.closeDialog();

                if (this.isOptionActive(option)) {
                    this.selectedOption = null;
                }
                else {
                    this.selectedOption = option.value;
                    this.search({
                        language: this.pageLang,
                        blockId: this.blockId,
                        challenge: this.selectedOption
                    });
                }

                if (dataLayer) {
                    dataLayer.push({
                        "event": "solution_selector_filter",
                        "filter_name": option.name,
                        "filter_position": index + 1
                    });
                }
                this.$router.push({
                    path: '',
                    query: { challenge: this.selectedOption }
                }).catch(err => { });
            },
            solutionClick: function (category, solution) {
                if (dataLayer) {
                    dataLayer.push({
                        "event": "solution_selector_solution",
                        "solution_category": category.name,
                        "solution_name": solution.title
                    });
                }
                this.setOpenDialog(category.value, solution.id);
            },
            isOptionActive: function (option) {
                return this.selectedOption === option.value;
            },
            getFilteredSolutionsPerCategory(category) {               
                return this.filteredSolutions && this.filteredSolutions.filter(s => s.solutionCategories && s.solutionCategories.includes(category));
            },
            isAriaHidden: function (category, id) {
                if (this.openDialog !== id + '-' + category) {
                    return "true";
                }
                else {
                    return "false";
                }
            },
            resetOptions: function () {
                this.selectedOption = null;
                this.$router.push({
                    path: '',
                    query: { challenge: null }
                }).catch(err => { });
            },
            findInOptions: function (value) {
                const option = this.options.find(item => item.value === value);
                if (option) {
                    return option.value;
                }
                return false;
            }
        }
    };
</script>
